@if (isLoading()) {
  <nz-skeleton
    [nzActive]="true"
    [nzTitle]="false"
    [nzParagraph]="{ rows: 1, width: '60%' }"
  ></nz-skeleton>
} @else if (comment()) {
  <div class="violation-comment">
    <label class="violation-comment__label">
      {{ 'page.shift.shift_report_comment' | translate }}
    </label>
    <p class="violation-comment__body">{{ comment() }}</p>
  </div>
}
